import * as _ from 'lodash';
import { TimeZones } from '../../core/timezones';


(function() {
  'use strict';

  function OrganisationSettingsController(
    RouterHelper,
    $scope,
    $rootScope,
    $translate,
    Organisations,
    Form,
    Utils,
    LocalizationService
  ) { // Replaced Router with RouterHelper
    var ctrl = this;

    ctrl.settings = {};

    function setForm(disableEnableLocalLoginOptionField) {
      ctrl.generalForm = new Form();

      Organisations.getClusterAvailableLanguages()
        .then(function(languages) {
          var defaultLanguageCode;
          var availableLanguagesOptions = _.map(languages, function(language) {
            if (language.is_default) {
              defaultLanguageCode = language.language_code;
            }
            return {
              _id: language.language_code,
              key: language.language_code,
              name: language.language_name
            };
          });
          var generalFields = [
            { id: 'general-legend', type: 'text_heading', label: $translate.instant('General') },
            { id: 'shortName', type: 'string', label: $translate.instant('Short Name') },
            { id: 'name', type: 'string', label: $translate.instant('Name') },
            {
              id: 'allowedAccountTypes',
              type: 'discrete_multiple',
              label: $translate.instant(
                'What kind of account is allowed to be created for admins? '
              ),
              helpText: $translate.instant('(the auto create will always work)'),
              options: [
                { _id: '__all__', key: '__all__', name: 'Any' },
                { _id: 'local', key: 'local', name: 'Local' },
                { _id: 'proxy', key: 'proxy', name: 'SSO' }
              ]
            },
            {
              id: 'accountTypeToCreateForSelfRegistration',
              type: 'discrete',
              label: $translate.instant(
                'What kind of account you would like to be create for the quick fill? '
              ),
              options: [
                { _id: '', key: '', name: 'No account need to be created on quick fill' },
                { _id: 'local', key: 'local', name: 'Local' },
                { _id: 'proxy', key: 'proxy', name: 'SSO' }
              ]
            },
            {
              id: 'allowedProducts',
              type: 'discrete_multiple',
              label: $translate.instant('Select products the organisation is allowed to use'),
              options: [
                { _id: 'kaizen', key: 'kaizen', name: 'risr/advance' },
                { _id: 'eas', key: 'eas', name: 'risr/apply' }
              ]
            },
            {
              id: 'languages',
              type: 'discrete_multiple',
              label: $translate.instant('Allowed Languages'),
              helpText: $translate.instant('Users will be able to switch languages'),
              options: availableLanguagesOptions,
              defaultValue: [defaultLanguageCode]
            },
            {
              id: 'enabledLabs',
              type: 'boolean',
              label: $translate.instant('Enable labs')
            },
            {
              id: 'enableLocalLoginOption',
              type: 'boolean',
              label: $translate.instant('Enable local login option'),
              disabled: disableEnableLocalLoginOptionField
            },
            {
              id: 'allowedSelfRegistration',
              type: 'boolean',
              label: $translate.instant('Enable local account self registration')
            },
            {
              id: 'disableAutoRegister',
              type: 'boolean',
              label: $translate.instant('Disable auto register via SSO'),
              helpText: $translate.instant('Require a local account when logging in via SSO')
            },
            {
              id: 'useIntegrationForSelfRegistration',
              type: 'boolean',
              label: $translate.instant(
                'Use Integration for self registration accounts? (if it exists one)'
              ),
              helpText: $translate.instant('Users will not be able to log in if disabled'),
              hideExpression: function(_$viewValue, _$modelValue, $scope) {
                return $scope.model.accountTypeToCreateForSelfRegistration !== 'proxy';
              }
            },
            {
              id: 'enabledMFAs',
              type: 'discrete_multiple',
              label: $translate.instant('Enabled Multi Factor Authentication methods'),
              options: [
                { _id: 'email_otp', key: 'email_otp', name: 'Email OTP' },
                { _id: 'totp', key: 'totp', name: 'Authenticator app' }
              ]
            },
            {
              id: 'supportDeskLink',
              type: 'string',
              label: $translate.instant('Support Desk Link'),
              helpText: $translate.instant(
                'The URL of the Issue Collector embedded Javascript source file. ' +
                'Disabled when left blank.'
              )
            },
            {
              id: 'disabled',
              type: 'boolean',
              label: $translate.instant('Organisation is disabled'),
              helpText: $translate.instant('Users will not be able to log in if disabled')
            }
          ];

          var generalGroup = ctrl.generalForm.addGroup();
          ctrl.generalForm.extend(generalFields, generalGroup);
        });

      ctrl.emailForm = new Form();

      var emailFields = [
        { id: 'email-legend', type: 'text_heading', label: $translate.instant('Email') },
        {
          id: 'email_from',
          type: 'string',
          label: $translate.instant('Specify email from address')
        },
        {
          id: 'email_disabled',
          type: 'boolean',
          label: $translate.instant('Do not send emails to real recipients')
        },
        {
          id: 'email_bcc_recipients',
          type: 'string',
          label: $translate.instant('Blind copy recipients')
        }
      ];

      var emailGroup = ctrl.emailForm.addGroup();
      ctrl.emailForm.extend(emailFields, emailGroup);

      ctrl.themeForm = new Form();

      var themeFields = [
        {
          id: 'theme-legend',
          type: 'text_heading',
          label: $translate.instant('Organisation theme')
        },
        {
          id: 'colors',
          type: 'json',
          label: $translate.instant('Colors')
        },
        {
          id: 'logos-legend',
          type: 'text_heading',
          label: $translate.instant('Organisation logos')
        },
        { id: 'logoDesktopPath', type: 'string', label: $translate.instant('Desktop logo path') },
        { id: 'logoMobilePath', type: 'string', label: $translate.instant('Mobile logo path') }
      ];

      var themeGroup = ctrl.themeForm.addGroup();
      ctrl.themeForm.extend(themeFields, themeGroup);

      ctrl.localizationForm = new Form();

      var dateTimeFormatOptions = LocalizationService.getDateTimeFormatOptions();

      var localizationFields = [
        {
          id: 'localization-legend',
          type: 'text_heading',
          label: $translate.instant('Localization')
        },
        {
          id: 'inputDateFormat',
          type: 'discrete',
          label: $translate.instant('Input Date format'),
          required: true,
          options: dateTimeFormatOptions.inputdate
        },
        {
          id: 'dateFormat',
          type: 'discrete',
          label: $translate.instant('Display Date format'),
          required: true,
          options: dateTimeFormatOptions.date
        },
        {
          id: 'timeFormat',
          type: 'discrete',
          label: $translate.instant('Display Time format'),
          required: true,
          options: dateTimeFormatOptions.time
        },
        {
          id: 'timezone',
          type: 'discrete',
          label: $translate.instant('Timezone'),
          options: _.map(TimeZones, function(itm) {
            return { _id: itm, key: itm, name: itm };
          })
        }
      ];
      var localizationGroup = ctrl.localizationForm.addGroup();
      ctrl.localizationForm.extend(localizationFields, localizationGroup);
    }

    ctrl.$onInit = function() {
      Organisations.find(ctrl.orgId)
        .then(function(data) {
          data.emailSetup = data.emailSetup || {};
          data.themeSetup = data.themeSetup || {};
          data.localizationSetup = data.localizationSetup || {};

          ctrl.emailSetup = data.emailSetup || {};
          if (ctrl.emailSetup.email_bcc_recipients) {
            ctrl.emailSetup.email_bcc_recipients = ctrl.emailSetup.email_bcc_recipients.join(', ');
          }

          var hasLocalLoginOption = false,
              hasProxyLoginOption = false,
              noLoginOptions = _.isUndefined(data.loginOptions) || _.isEmpty(data.loginOptions);
          _.forEach(data.loginOptions, function(loginOption) {
            if (loginOption.type === 'local') {
              hasLocalLoginOption = true;
            } else if (loginOption.type === 'proxy') {
              hasProxyLoginOption = true;
            }
          });

          data.enableLocalLoginOption = hasLocalLoginOption || noLoginOptions;

          var disableEnableLocalLoginOptionField = !hasProxyLoginOption;
          setForm(disableEnableLocalLoginOptionField);

          ctrl.settings = data;
          Utils.setPageTitle('Edit organisation: ' + data.name);
          ctrl.loaded = true;
        });
    };

    ctrl.cancel = function() {
      RouterHelper.navigate(['/organisations']);
    };

    $scope.$watch(function() {
      return (ctrl.settings.themeSetup || {}).theme;
    }, function(value) {
      $rootScope.$broadcast('OrganisationTryTheme', { theme: value });
    });

    var transform = function(obj, transformers) {
      transformers.forEach(function(fn) {
        obj = fn(obj);
      });

      return obj;
    };

    var transformEmailSetup = function(emailSetup) {
      var setup = angular.copy(emailSetup);
      setup.email_bcc_recipients = _.map(emailSetup.email_bcc_recipients.split(','), function(itm) {
        return itm.trim();
      });
      return setup;
    };

    var colorsStringToJson = function(obj) {
      // When we save the form without making changes to the colors field
      // it's not a string, so we don't need to parse it
      if (obj.themeSetup.colors && typeof obj.themeSetup.colors === 'string') {
        try {
          obj.themeSetup.colors = JSON.parse(obj.themeSetup.colors);
        } catch (e) {
          // We ignore it
        }
      }
      return obj;
    };

    ctrl.save = function(isValid) {
      ctrl.formIsSubmitted = true;

      if (isValid) {
        ctrl.settings.emailSetup = transformEmailSetup(ctrl.emailSetup);
        ctrl.settings._id = ctrl.orgId;
        // TODO: Is there a better way to do this?
        // Apply any modifications to the form data
        ctrl.settings = transform(ctrl.settings, [colorsStringToJson]);


        Organisations.save(ctrl.settings)
          .then(function() {
            $rootScope.$broadcast('OrganisationSettingsChanged', { org: ctrl.settings });
            RouterHelper.navigate(['/organisations']);
          })
          .catch(Utils.showError);
      } else {
        Utils.showError({ message: 'Form is not valid' });
      }
    };
  }

  OrganisationSettingsController.$inject = [
    'RouterHelperService',
    '$scope',
    '$rootScope',
    '$translate',
    'OrganisationsService',
    'FormsService',
    'UtilsService',
    'LocalizationService'


  ];

  angular.module('component.organisations')
    .component('organisationSettings', {
      templateUrl: 'app/components/organisations/settings.html',
      controller: OrganisationSettingsController,
      controllerAs: 'organisationSettingsCtrl',
      bindings: {
        orgId: '<'
      }
    });
})();
